<template>
  <AppLayout>
    <div class="flex flex-col w-full">
      <div
        class="w-full flex-nowrap shadow-md p-2 bg-light dark:bg-gray-800 inline-flex justify-end items-center gap-2"
      >
        <form inline @submit.prevent="search">
          <InputText
            v-model="query"
            data-testid="search-input"
            name="query"
            class="w-[350px] mb-2 sm:mr-2 sm:mb-0"
            :placeholder="$t(`messages.searchPage.placeholder`)"
          />
          <Button variant="primary" data-testid="search-submit" class="mb-2 sm:mr-2 sm:mb-0" :disabled="!query" type="submit">
            <span class="pi pi-search" v-if="!loading"></span>
            <span class="pi pi-spin pi-spinner" v-else></span>
            <span class="hidden sm:inline">{{ $t('messages.search') }}</span>
          </Button>
          <Button
            variant="light"
            class="mb-2 sm:mb-0"
            :disabled="!query"
            @click.stop.prevent="reset"
          >
            <span class="pi pi-times"></span>
          </Button>
        </form>
      </div>
      <Deferred data="result">
        <template #fallback>
          <div class="m-2 text-center">
            <ProgressSpinner class="align-middle"></ProgressSpinner>
            <strong>{{ $t('messages.loading') }}...</strong>
          </div>
        </template>
        <SearchResultsComponent class="results" :rows="results" :loading="loading" />
      </Deferred>
    </div>
  </AppLayout>
</template>

<script setup>
import { Deferred, router } from '@inertiajs/vue3'
import { computed, onMounted, ref } from 'vue'
import SearchResultsComponent from '../components/search/SearchResultsComponent.vue'
import AppLayout from '../Layouts/AppLayout.vue'

const props = defineProps({
  searchQuery: {
    type: String,
    default: '',
  },
  result: {
    type: Object,
    default: () => ({
      type: 'ehr',
      data: [],
    }),
  },
})

const query = ref(props.searchQuery)
const error = ref('')
const loading = ref(false)
const results = computed(() => props.result.data)

onMounted(() => {
  query.value = props.searchQuery.trim()
})

const reset = () => {
  query.value = ''
  loading.value = false
  error.value = ''
  results.value = []
  window.history.pushState(query.value, '', `/search`)
}

const search = () => {
  if (!query.value || query.value.length < 3) {
    return
  }
  fetch()
}

const fetch = () => {
  loading.value = true
  router.get(
    `/search?query=${query.value}`,
    {},
    {
      preserveScroll: true,
      preserveState: true,
      only: ['result', 'systemAlerts', 'unreadNotificationsCount'],
      onSuccess: ({ props }) => {
        if (
          props.result.type === 'cadaster' &&
          props.result.data.length === 1
        ) {
          router.visit(`/detail?cadaster-id=${props.result.data[0].cadaster}`)
        }
      },
      onFinish: () => {
        loading.value = false
      },
    },
  )
}
</script>
